import {
  FaTasks,
  FaArrowsAltV,
  FaShieldAlt,
  FaProjectDiagram,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-gitlabrunner.png";

export const GITLAB_CONSTANTS = {
  HERO: {
    title: "OneMind Services — GitLab Runner (One-Click Application) ",
    desc: "Streamline your CI/CD processes with OneMind’s fully managed GitLab Runner. We handle the infrastructure, so you can focus on delivering quality code faster.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "GitLab Runner is an open-source application that works with GitLab CI/CD to run jobs in a pipeline. It executes the commands defined in .gitlab-ci.yml and reports the results back to GitLab.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure GitLab Runner instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes GitLab Runner, default configurations, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "root",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Register your runner with your GitLab instance using the following command: ",
      command: "gitlab-runner register ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: "/etc/gitlab-runner/config.toml  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["8093 (default for GitLab Runner) "],
    },
    note: "Note : Find the configuration file at /etc/gitlab-runner/config.toml for customized tweaks or backup.",
  },
  FEATURES: {
    items: [
      {
        icon: FaTasks,
        title: "Multiple Executor Support",
        text: "Supports various executors like Shell, Docker, and Kubernetes for flexible job execution.",
      },
      {
        icon: FaArrowsAltV,
        title: "Autoscaling",
        text: "Automatically scales runners based on the workload, optimizing resource usage.",
      },
      {
        icon: FaShieldAlt,
        title: "Secure Execution",
        text: "Isolates job execution environments to enhance security and prevent interference.",
      },
      {
        icon: FaProjectDiagram,
        title: "Easy Integration",
        text: "Seamlessly integrates with GitLab CI/CD pipelines for streamlined development workflows.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for GitLab Runner configurations.",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and access control configurations. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with Docker or Kubernetes for enhanced performance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "GitLab Runner Documentation",
    docsLink: "https://docs.gitlab.com/runner/",
  },
};
